module.exports = __webpack_public_path__ + "img/public/siteImages/rightSideArrow.svg?0006e35d";